export default __webpack_public_path__ + "static/media/Restauraten.f91f5ce6.jpg";